export default __webpack_public_path__ + "static/media/project_uncontracted_on.df9ebb15.svg";